const UtmTags = () => {
  const url = document.location.href,
    paramsStartIndex = url.indexOf("?"),
    metaTags = url.slice(paramsStartIndex + 1, url.length);
    
  /* Установка cookie */
  function setCookie(name, value, options = {}) {
    options = {
      path: "/",
      // при необходимости добавьте другие значения по умолчанию
      ...options,
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie =
      encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }

  if (paramsStartIndex > -1) {
    // Добавление UTM меток в cookie
    if (metaTags.includes("category") || metaTags.includes("level") || metaTags.includes("format")) {
      console.log("repeatCookie");
      return;
    }

    setCookie("utm_tags", metaTags, { "max-age": 86400 });

    console.log("setCookie");
  }
};

export default UtmTags;
